import React from "react";

const MicOff = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="white-on-shout"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.35646 6.51465L13.542 13.0749V11.2083C13.542 9.43642 14.9784 8 16.7503 8C18.5223 8 19.9587 9.43642 19.9587 11.2083V15.3917C19.9587 16.3883 19.5042 17.2788 18.7912 17.8673L19.9322 18.9089C20.7193 18.2545 21.251 17.286 21.251 15.9502H22.751C22.751 17.6545 22.0833 18.9956 21.0475 19.9272L28.5366 26.7646L27.2661 28.1562L5.08594 7.90628L6.35646 6.51465ZM12.3876 17.0565C12.599 17.8601 13.0415 18.4828 13.6128 18.9442C14.1158 19.3504 14.7321 19.6412 15.4005 19.8072L18.0551 22.2309V24.9598H15.4469V21.3511C14.438 21.1644 13.4688 20.756 12.6704 20.1112C11.5123 19.1759 10.751 17.7702 10.751 15.9502H11.1758L12.3876 17.0565Z"
        fill="#A6A6A6"
      />
    </svg>
  );
};

export default MicOff;
